import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Col, FloatingLabel, Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../../layouts/PageLayout";
import FundsDashboardRecord from "./FundsDashboardRecord";

const FundsDashboard = () => {
  const [identifiers, setIdentifiers] = useState([]); 
  const [formState, setFormState] = useState({
    from_date: "",
    to_date: "",
  });
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  // Fetch identifiers on initial load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          process.env.REACT_APP_API_URL + "/finance-initial-data"
        );
        setIdentifiers(res.data.identifiers);
        setData(res.data); // store main data
      } catch (error) {
        console.log(error, "finance-initial-data");
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...formState, [name]: value };
    setFormState(updatedState);

    const { from_date, to_date } = updatedState;
    if (
      (from_date && to_date && new Date(to_date) >= new Date(from_date)) ||
      (!from_date && !to_date)
    ) {
      setError("");
    }
  };

  const handleApplyFilter = async () => {
    const { from_date, to_date } = formState;

    if (!from_date && !to_date) {
      setError("Please enter from_date and to_date.");
      return;
    }
    if (from_date && !to_date) {
      setError("Please select a 'To Date' when 'From Date' is chosen.");
      return;
    }
    if (!from_date && to_date) {
      setError("Please select a 'From Date' when 'To Date' is chosen.");
      return;
    }
    if (from_date && to_date && new Date(to_date) < new Date(from_date)) {
      setError("'To Date' cannot be earlier than 'From Date'.");
      return;
    }

    setError("");
    try {
      const params = {};
      if (formState?.from_date) params.from_date = formState.from_date;
      if (formState?.to_date) params.to_date = formState.to_date;

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/finance-initial-data`,
        { params }
      );
      setData(response.data);
      setIdentifiers(response.data.identifiers);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  const handleClearFilter = async () => {
    try {
      setFormState({ from_date: "", to_date: "" });
      setError("");
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/finance-initial-data"
      );
      setData(response.data);
      setIdentifiers(response.data.identifiers);
    } catch (error) {
      console.error("Error clearing filter:", error);
    }
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Funds Dashboard</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    Finances
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Funds Dashboard</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      {/* Filter Section */}
      <Row>
        <Col xl={12}>
          <div className="mc-card p-3">
            <h5 className="fw-bold mb-3">Filter by Date</h5>
            <Row className="align-items-center g-3">
              <Col md="auto">
                <Form.Label className="mb-0">From:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="date"
                  name="from_date"
                  value={formState.from_date}
                  onChange={handleChange}
                />
              </Col>

              <Col md="auto">
                <Form.Label className="mb-0">To:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="date"
                  name="to_date"
                  value={formState.to_date}
                  onChange={handleChange}
                />
              </Col>

              <Col md="2">
                <Button
                  onClick={handleApplyFilter}
                  style={{
                    backgroundColor: "#077834",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  Apply Filter
                </Button>
              </Col>
              <Col md="2">
                <Button
                  onClick={handleClearFilter}
                  className="bg-secondary"
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  Clear Filter
                </Button>
              </Col>
            </Row>
            {error && (
              <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                {error}
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Records Section */}
      <Row>
        <FundsDashboardRecord data={data} identifiers={identifiers} />
      </Row>
    </PageLayout>
  );
};

export default FundsDashboard;
